var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHot28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.604 23.254a9.346 9.346 0 0 0 2.746-6.629c0-6.15-5.171-11.784-7.833-14.276-.608-.57-1.55-.12-1.6.712-.514 8.47-4.244 7.932-5.845 7.297-.44-.176-.971-.125-1.277.238A9.337 9.337 0 0 0 4.6 16.625a9.346 9.346 0 0 0 2.746 6.63A9.346 9.346 0 0 0 13.975 26a9.345 9.345 0 0 0 6.63-2.746Zm-3.8-2.465a4.192 4.192 0 0 0 1.171-2.923c0-2.067-1.333-3.985-2.222-5.034-.282-.333-.787-.125-.822.309-.341 4.233-2.613 4.493-3.853 3.476-.315-.258-.855-.245-.96.148-.093.35-.143.72-.143 1.1 0 1.142.448 2.176 1.172 2.924A3.923 3.923 0 0 0 13.975 22a3.924 3.924 0 0 0 2.828-1.21Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot28);
export default __webpack_public_path__ + "static/media/hot_28.31040799.svg";
export { ForwardRef as ReactComponent };